<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h630_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogAddEditViewForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专卖证号">
                  <el-input
                    v-model="dialogAddEditViewForm.certificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="店名"
                  prop="storeName"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.storeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="地址">
                  <el-input
                    v-model="dialogAddEditViewForm.address"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="实际店名">
                  <el-input
                    v-model="dialogAddEditViewForm.realStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="实际地址">
                  <el-input
                    v-model="dialogAddEditViewForm.realAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="申请日期"
                  prop="applyDate"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.applyDate"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属方案编号"
                  prop="schemeId"
                >
                  <el-select
                    v-model="dialogAddEditViewForm.schemeId"
                    filterable
                    placeholder="请选择所属方案"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in schemeOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    >
                      <span style="float: left">{{ item.label }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.schemeNo }} ({{ item.schemeType }})</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="停用专卖证号">
                  <el-input
                    v-model="dialogAddEditViewForm.stopCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="停用店名">
                  <el-input
                    v-model="dialogAddEditViewForm.stopStoreName"
                    disabled
                  >
                    <el-button
                      v-if="eventType !== 'view'"
                      slot="append"
                      icon="el-icon-search"
                      @click="showStopStoreFun()"
                    />
                    <el-button
                      slot="append"
                      icon="el-icon-delete"
                      @click="clearStopStoreFun()"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="停用地址">
                  <el-input
                    v-model="dialogAddEditViewForm.stopAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="停用实际店名">
                  <el-input
                    v-model="dialogAddEditViewForm.stopRealStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="停用实际地址">
                  <el-input
                    v-model="dialogAddEditViewForm.stopRealAddress"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="审核结果"
                  prop="checkResult"
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.checkResult"
                    @change="clearStopStoreFun()"
                  >
                    <el-radio :label="1">
                      通过
                    </el-radio>
                    <el-radio :label="2">
                      不通过
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="申请说明"
                  prop="applyDescription"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.applyDescription"
                    type="textarea"
                    maxlength="512"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    maxlength="512"
                    placeholder="备注"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 终端列表 -->
    <scheme-store-list-dialog
      :dialog-visible.sync="dialogStoreVisible"
      :scheme-id="schemeId"
      dialog-title="终端信息"
      @selectedStoreFun="selectedStoreFun"
    />
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 选择终端
import schemeStoreListDialog from './schemeStoreListDialog'
// 终端恢复申请API
import { viewSchemeStoreVisitRestoreApplyApi, checkSchemeStoreVisitRestoreApplyApi } from '@/api/v2/schemeStoreVisitRestoreApply';
import {listSchemeApi } from '@/api/v2/scheme'

export default {
  components: { schemeStoreListDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      expandMoreData: false,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        schemeId: [{ required: true, message: '请选择所属方案', trigger: 'change' }],
        remark: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' }]
      },
      dialogStoreVisible: false,
      schemeOptions: [],
      schemeId: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.schemeOptions = []
        _this.dialogAddEditViewForm = {
          provinceName: '',
          cityName: '',
          schemeName: '',
          schemeNo: '',
          certificateNo: '',
          storeName: '',
          applyStoreId: '',
          address: '',
          realStoreName: '',
          realAddress: '',
          stopCertificateNo: '',
          stopStoreName: '',
          stopStoreId: 0,
          stopAddress: '',
          stopRealStoreName: '',
          stopRealAddress: '',
          applyDate: '',
          applyDescription: '',
          checkResult: 1,
          remark: ''
        }
        _this.loadSchemeStoreVisitRestoreApplyData();

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    },
  },
  methods: {
    // 加载终端恢复申请数据
    loadSchemeStoreVisitRestoreApplyData () {
      let _this = this;
      viewSchemeStoreVisitRestoreApplyApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        for (let key in _this.dialogAddEditViewForm) {
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id;
        _this.dialogAddEditViewForm.checkResult = 1
        _this.initSchemeListFun(data.provinceId)
      })
    },
    initSchemeListFun(provinceId){
      let _this = this;
      let params = {
        schemeType: 3,
        status: 2,
        schemeStatus: 1,
        provinceId: provinceId
      }
      listSchemeApi(params).then(response => {
        const { data } = response
        data.forEach(item => {
          _this.schemeOptions.push({ label: item.name, data: item.id, name: item.name, schemeNo: item.projectNo, schemeType: item.schemeTypeValue })
        })
        _this.loading = false
      })
    },
    showStopStoreFun(){
      let _this = this
      if(!_this.dialogAddEditViewForm.schemeId){
        _this.$message({ message: '请选择所属方案', type: 'warning' })
        return false
      }
      _this.schemeId = _this.dialogAddEditViewForm.schemeId
      _this.dialogStoreVisible = true
    },
    // 选择终端
    selectedStoreFun (val) {
      let _this = this;
      _this.dialogAddEditViewForm.stopStoreId = val.storeId
      _this.dialogAddEditViewForm.stopCertificateNo = val.certificateNo
      _this.dialogAddEditViewForm.stopStoreName = val.storeName
      _this.dialogAddEditViewForm.stopAddress = val.address
      _this.dialogAddEditViewForm.stopRealStoreName = val.realStoreName
      _this.dialogAddEditViewForm.stopRealAddress = val.realAddress
    },
    clearStopStoreFun(){
      let _this = this
      _this.dialogAddEditViewForm.stopStoreId = 0
      _this.dialogAddEditViewForm.stopCertificateNo = ''
      _this.dialogAddEditViewForm.stopStoreName = ''
      _this.dialogAddEditViewForm.stopAddress = ''
      _this.dialogAddEditViewForm.stopRealStoreName = ''
      _this.dialogAddEditViewForm.stopRealAddress = ''
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false);
      _this.imageFileList = [];
      _this.$refs.dialogAddEditViewForm.clearValidate();
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm('是否确定复核该终端恢复申请信息', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            checkSchemeStoreVisitRestoreApplyApi(_this.dialogAddEditViewForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.explain-tooltip {
  float: right;
  margin-top: 10px;
  margin-right: 15px;
  color: white;
  cursor: pointer;
}
</style>
